var render, staticRenderFns
import script from "./design.vue?vue&type=script&lang=ts&"
export * from "./design.vue?vue&type=script&lang=ts&"
import style0 from "./design.vue?vue&type=style&index=0&id=169cb15e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169cb15e",
  null
  
)

export default component.exports